import APIS from 'src/constants/ApiConfig';
import { IAgentSetting, IAgentInfo } from 'src/entity/AgentEntity';
import HttpService from 'src/services/HttpService';

class AgentClass {
  /**
   * 更新代理商设置
   *
   * @param {IAgentSetting} data
   * @returns {Promise<IAgentInfo>}
   * @memberof AgentClass
   */
  updateAgentSetting(data: IAgentSetting): Promise<IAgentInfo> {
    return HttpService.patch(APIS.domainUrl(APIS.agentSelf), data);
  }
}

export default new AgentClass();



// WEBPACK FOOTER //
// ./src/services/AgentService.ts